<template>
  <div>
    <div class="head">
      <el-form ref="form" :model="searchForm" inline class="form" @submit.native.prevent>
        <el-form-item>
          <el-input
            placeholder="请输入关键字搜索"
            prefix-icon="el-icon-search"
            clearable
            v-model="searchForm.strtitle"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="seachTitle" type="color">搜一下</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="GlobalContainer container">
      <div class="globalTitle">
        <div>
          <h3>搜索结果</h3>
          <span style="color: #e5e5e5">|</span>
          <span>SEARCH RESULT</span>
        </div>
      </div>
      <el-divider></el-divider>
      <ul class="AllType">
        <li
          v-for="(i, n) in ProList"
          :key="n"
          @click="changeType(n)"
          :class="NowFocus == n ? 'focus' : ''"
        >{{ i }}</li>
      </ul>
      <div class="dataNum">
        已为您筛选 &nbsp;
        <span>{{ total }}</span>&nbsp;条数据
      </div>
      <!-- 需求库/成果库 -->
      <ul v-if="NowFocus == 0 || 1" class="NowResult">
        <li
          v-for="(i, n) in cardArr"
          :key="n"
          @mouseenter="ResultActive = n"
          :class="ResultActive === n ? 'isResFocus' : ''"
          @click="goDetail(i)"
        >
          <div class="leftContent">
            <h3>{{ i.Title }}</h3>

            <p class="text_content" v-if="NowFocus == 0">{{ i.ResultsInformation }}</p>
            <p class="text_content" v-if="NowFocus == 1">{{ i.CompanyProfile }}</p>
            <div class="xing_wrap" v-if="NowFocus == 0">
              <span class="huang" v-for="i of i.Score" :key="i+1000">
                <img src="../assets/library/chengguo/星星.png" alt />
              </span>
              <span class="hui" v-for="i of 5 - i.Score" :key="i+2000">
                <img src="../assets/library/chengguo/星星(1).png" alt />
              </span>
            </div>
            <div class="xing_wrap" v-if="NowFocus == 1">
              <span class="huang" v-for="i of i.Upload" :key="i+3000">
                <img src="../assets/library/chengguo/星星.png" alt />
              </span>
              <span class="hui" v-for="i of 5 - i.Upload" :key="i+4000">
                <img src="../assets/library/chengguo/星星(1).png" alt />
              </span>
            </div>
          </div>
          <div class="rightContent" v-if="NowFocus == 0">
            <p class="top">所需资金：</p>
            <p class="botm" v-if="i.InvestInFunds || i.InvestInFunds !== 0">
              <span>￥</span>
              {{ i.InvestInFunds }}
            </p>
            <p class="botm" v-else>
              <span></span>面议
            </p>
          </div>
        </li>
      </ul>
      <!-- 人才库 -->
      <ul v-if="NowFocus == 2" class="PersonalContainer">
        <li class="PersonalInfo" v-for="(i, n) in personalList" :key="n" @click="goTalentDetail(i)">
          <div class="Name">
            <p>{{ i.FullName }}</p>
            <span>{{ i.TechnicalPosition }}</span>
            <img v-if="i.Sex == 0" src="../assets/library/蒙版组 125.png" alt />
            <img v-else src="../assets/library/蒙版组 125@2x.png" alt />
          </div>

          <p>{{ i.University }}</p>
          <div class="specialLen">
            <span>{{ i.Direction.split("|")[0] }}</span>
            <i>|</i>
            <span>{{ i.Direction.split("|")[1] }}</span>
          </div>
          <el-button v-if="i.Collection == 'yes'" @click.stop="follow(i)" type="primary">已关注</el-button>
          <el-button v-else @click.stop="follow(i)" type="primary">+关注</el-button>
        </li>
      </ul>
      <div v-if="NowFocus == 3" class="card_box">
        <div
          class="card"
          v-for="(item, index) in organArr"
          :key="index"
          @click="goOrganDetail(item)"
        >
          <img :src="item.Logo" alt />
          <div class="card_text">
            <p class="card_name">{{ item.UnitName }}</p>
            <p class="card_add" v-if="item.Address">{{ item.Address }}</p>
            <p class="card_add" v-else>&nbsp;</p>
            <div class="card_pop_wrap" v-if="item.TechFieldEnum.length > 0">
              <span class="card_pop" v-for="(v, i) in item.TechFieldEnum" :key="i">{{ v }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="yunshow" v-if="(NowFocus == 4 || 5 || 6)&&total!=0">
        <div class="yunshow_wrap" v-for="(v, i) in hallArr" :key="i" @click="goHall(v)">
          <div class="img_box">
            <img :src="v.PictureUrl" alt />
          </div>
          <div class="text_box">
            <p class="title">{{ v.Title }}</p>
            <p class="danwei">单位名称：{{ v.Company }}</p>
            <p class="danwei">合作方式：</p>
            <p class="danwei">项目阶段：试生产</p>
          </div>
        </div>
      </div>
      <div v-if="NowFocus == 7 || 8 || 9" class="new">
        <div class="item" v-for="(i, n) in newsArr" @click="ToNewsInfo(i)" :key="n">
          <div class="totle">
            <p>{{ i.CreateTime.substring(8, 10) }}</p>
            <div class="totledate-bottom">
              <p>{{ i.CreateTime.substring(0, 7).replace("-", "年") }}月</p>
            </div>
          </div>
          <div class="content">
            <b>{{ i.Titile }}</b>
            <div class="con-div">{{ i.ShortDetails }}</div>
          </div>
        </div>
      </div>
      <Pagination
        :limit.sync="searchForm.size"
        :page.sync="searchForm.page"
        :total="total"
        @pagination="loadData"
      />
      <empty v-show="total === 0" />
    </div>
  </div>
</template>

<script>
import Pagination from './library/components/Pagination/index.vue'
import empty from '../components/empty.vue'
import $ from '../../public/jquery-2.1.1'
import { getAction, postAction } from '../api/api'
import {
  library,
  demandList,
  Talent,
  organPool,
  Notice,
  cloudSelect,
  roldList,
} from '../api/url'
export default {
  components: { Pagination, empty },
  data() {
    return {
      ProList: [
        '技术成果库',
        '技术需求库',
        '高层次人才库',
        '创新平台',
        '成果厅',
        '需求厅',
        '云路演',
        '通知公告',
        '政策资讯',
        '产经资讯',
      ],
      NowFocus: 0,
      total: 0,
      searchForm: {
        strtitle: '', // 	搜索关键字
        size: 10,
        page: 1,
      },

      result: {
        //成果列表请求条件
        action: 'Get_AchievementList',
        page: 1,
        pageSize: 10,
        strSort: '',
        strTechFieldEnum: '',
        strPropertystatus: '',
        strProjectPhase: '',
        strCooperaType: '',
        strBudgetary: '',
        strtitle: '',
        strCountries: '',
        strProvinces: '',
        strCitys: '',
        strCountryText: '',
        strAwardLevel: '',
        strOwnershipOfResults: '',
        strLibraries: '',
        strEnterpriseType: '',
      },
      Needs: {
        action: 'Demand_BindList',
        pageSize: 10,
        page: 1,
        strTechFieldEnum: '',
        strBudgetary: '',
        strCooperaType: '',
        strReleaseTime: '',
        strEnterpriseType: '',
        strCountries: '',
        strDemandType: '',
        strSort: '',
        strtitle: '',
        strIsDemand: '',
      },
      personal: {
        action: 'TrpersonnelReg_bindlist',
        pageSize: 12,
        page: 1,
        name: '',
        strTechField: '',
        strCategory: '',
        strprovince: '',
        userid: 0,
        strSort: '',
      },
      orgnaiZation: {
        action: 'Get_OrganizationList',
        pageSize: 9,
        page: 1,
        strTitle: '',
        strTechFieldEnum: '',
        strType: '',
        strProvinces: '',
        strCitys: '',
        strSort: '',
        srtTime: '',
      },
      NewsForm: {
        action: 'Get_Information',
        pageSize: 10,
        page: 1,
        keywords: '',
      },
      policyForm: {
        region: '',
        limit: 10,
        skip: 1,
        q: '',
      },
      chengguoForm: {
        action: 'AchievementsSearch_BindList',
        keywords: '',
        pageSize: 10,
        page: 1,
      },
      xuqiuForm: {
        action: 'DemandSearch_BindList',
        keywords: '',
        pageSize: 10,
        page: 1,
      },
      roadShow: {
        action: 'Get_RoadShowWebList',
        state: '1',
        pageSize: 10,
        page: 1,
        sort: 'UpdateTime DESC',
        TechFieldEnum: '',
        TechnologySource: '',
        keywords: '',
      },
      cardArr: [],
      personalList: [],
      organArr: [],
      hallArr: [],
      newsArr: [],
      ResultActive: 0,
    }
  },
  created() {
    this.searchForm.strtitle = this.$route.query.value
    this.loadData()
  },
  mounted() {
    this.$bus.$on('LoginSuccess', (e) => {
      //// console.log(e);
      if (e) {
        this.loadPersonal()
      }
    })
  },
  methods: {
    seachTitle() {
      this.loadData()
    },
    changeType(n) {
      this.NowFocus = n
      //// console.log(this.NowFocus);
      this.cardArr = []
      this.personalList = []
      this.organArr = []
      this.hallArr = []
      this.newsArr = []
      this.total = 0
      this.loadData()
    },
    loadData() {
      if (this.searchForm.strtitle == '') {
        return (this.total = 0)
      }
      switch (this.NowFocus) {
        case 0:
          this.result.strtitle = this.searchForm.strtitle
          this.result.page = this.searchForm.page
          this.result.pageSize = this.searchForm.size

          this.loadResult()
          break
        case 1:
          this.Needs.strtitle = this.searchForm.strtitle
          this.Needs.page = this.searchForm.page
          this.Needs.pageSize = this.searchForm.size

          this.loadNeeds()
          break
        case 2:
          this.personal.name = this.searchForm.strtitle
          this.personal.page = this.searchForm.page
          this.personal.pageSize = this.searchForm.size
          this.loadPersonal()
          break
        case 3:
          this.orgnaiZation.strTitle = this.searchForm.strtitle
          this.orgnaiZation.page = this.searchForm.page
          this.orgnaiZation.pageSize = this.searchForm.size
          this.loadOrgZation() //创新平台
          break
        case 4:
          this.chengguoForm.keywords = this.searchForm.strtitle
          this.chengguoForm.page = this.searchForm.page
          this.chengguoForm.pageSize = this.searchForm.size
          this.loadChengguo()
          break
        case 5:
          this.xuqiuForm.keywords = this.searchForm.strtitle
          this.xuqiuForm.page = this.searchForm.page
          this.xuqiuForm.pageSize = this.searchForm.size
          this.loadXuqiu()
          break
        case 6:
          this.roadShow.keywords = this.searchForm.strtitle
          this.roadShow.page = this.searchForm.page
          this.roadShow.pageSize = this.searchForm.size
          this.loadRoadShow()
          break
        case 7:
          this.NewsForm.keywords = this.searchForm.strtitle
          this.NewsForm.page = this.searchForm.page
          this.NewsForm.pageSize = this.searchForm.size
          this.loadNews(0)
          break
        case 8:
          this.policyForm.limit = this.searchForm.size
          this.policyForm.skip = this.searchForm.page
          this.policyForm.q = this.searchForm.strtitle
          this.loadNews(1)
          break
        case 9:
          this.policyForm.limit = this.searchForm.size
          this.policyForm.skip = this.searchForm.page
          this.policyForm.q = this.searchForm.strtitle
          this.loadNews(2)
          break
      }
    },
    loadResult() {
      getAction(library, this.result).then((res) => {
        //// console.log(res);
        res.data.map((item) => {
          item.Score = Number(item.Score)
          //// console.log(item.Score);
        })
        //// console.log(res);
        this.cardArr = res.data
        this.total = res.count
      })
    },
    loadNeeds() {
      getAction(demandList, this.Needs).then((res) => {
        // res.data.map((item) => {
        //   item.Score = Number(item.Score);
        //   //// console.log(item.Score);
        // });

        res.data.map((item) => {
          if (item.Upload == 'A') {
            item.Upload = 5
          } else if (item.Upload == 'B') {
            item.Upload = 4
          } else if (item.Upload == 'C') {
            item.Upload = 3
          } else if (item.Upload == 'D') {
            item.Upload = 2
          } else if (item.Upload == 'E') {
            item.Upload = 1
          }
        })
        //// console.log(res);
        this.cardArr = res.data
        this.total = res.data.length
      })
    },
    loadPersonal() {
      this.personal.userid = localStorage.getItem('RealID')
      getAction(Talent, this.personal).then((res) => {
        //// console.log(res);

        this.personalList = res.data

        //// console.log(this.personalList, "personalList", this.NowFocus);
        if (res.data.length <= 0) {
          this.total = 0
        } else {
          this.total = res.count
        }
      })
    },
    loadOrgZation() {
      postAction(organPool, this.$qs.stringify(this.orgnaiZation)).then(
        (res) => {
          res.data.map((item) => {
            if (item.TechFieldEnum !== '') {
              item.TechFieldEnum = item.TechFieldEnum.split(',')
            }
          })
          this.organArr = res.data
          //// console.log('organArr',res.data)
          //// console.log(this.cardArr);
          if (res.data.length <= 0) {
            this.total = 0
          } else {
            this.total = res.count
          }
        }
      )
    },
    loadNews(type) {
      if (type == 0) {
        //// console.log(this.NewsForm);
        postAction(Notice, this.$qs.stringify(this.NewsForm)).then((res) => {
          //// console.log(res);
          this.total = res.count
          this.newsArr = res.data
        })
        this.$forceUpdate()
      } else {
        let vm = this
        let url1 =
          'http://122.112.231.161:13500/r4QwXEGi/api/industry/category/search'
        let url2 =
          'http://122.112.231.161:13500/r4QwXEGi/api/policy/category/search'
        $.ajax({
          type: 'get',
          url: type == 1 ? url1 : url2,
          data: {
            region: vm.policyForm.region,
            limit: vm.policyForm.limit,
            skip: vm.policyForm.skip,
            q: vm.policyForm.q,
          },
          datatype: 'json',
          async: false,
          success: function (data) {
            let TzggData = eval('(' + data + ')')
            vm.total = TzggData.count
            vm.dataList = TzggData.data
            vm.dataList.forEach((item) => {
              let ZcData = {
                Titile: item.name,
                CreateTime: item.properties.发布时间,
                ShortDetails: item.properties.简介,
                Spare1: item.properties.发布时间.substring(5, 10),
                ID: item._id,
              }
              vm.newsArr.push(ZcData)
            })
            //// console.log(vm.newsArr);
            if (vm.newsArr.length == 0) {
              //// console.log(11111)
              vm.total = 0
            }
          },
        })
      }
    },
    loadChengguo() {
      getAction(cloudSelect, this.chengguoForm).then((res) => {
        //// console.log(res);
        this.hallArr = res.data
        if (res.data.length <= 0) {
          this.total = 0
        } else {
          this.total = res.count
        }
      })
    },
    loadXuqiu() {
      getAction(cloudSelect, this.xuqiuForm).then((res) => {
        //// console.log(res);
      })
    },
    loadRoadShow() {
      // //// console.log('1111111111122222222222222222222')
      postAction(roldList, this.$qs.stringify(this.roadShow)).then((res) => {
        //// console.log('1111111111111111111111',res);
        this.hallArr = res
        this.total = res.count
      })
    },
    goDetail(a) {
      //// console.log(a);
      if (this.NowFocus == 0) {
        const { href } = this.$router.resolve({
          path: '/fruitDetail',
          query: {
            id: a.ID,
          },
        })
        window.open(href, '_blank')
      } else {
        const { href } = this.$router.resolve({
          path: '/demandDetail',
          query: {
            id: a.ID,
          },
        })
        window.open(href, '_blank')
      }
    },
    goTalentDetail(item) {
      //人才详情
      const { href } = this.$router.resolve({
        path: '/talentPoolinfo',
        query: {
          list: item.ID,
        },
      })
      window.open(href, '_blank')
    },
    follow(a) {
      let RealName = localStorage.getItem('RealName')
      if (!RealName == '') {
        let data = {
          action: 'Collection_Items',
          UserID: localStorage.getItem('RealID'),
          ProjectID: a.ID,
          Type: 3,
        }
        postAction(library, this.$qs.stringify(data)).then((res) => {
          //// console.log(res);
          if (res.status == 'y') {
            this.$message.success('关注成功！')
          } else {
            this.$message.success('取消关注')
          }
          this.loadPersonal()
        })
      } else {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      }
    },
    goOrganDetail(a, b) {
      //// console.log(a);
      // //// console.log(this.searchForm.strType)
      const { href } = this.$router.resolve({
        path: '/OrganizationDetail',
        query: {
          id: a,
          type: b,
        },
      })
      window.open(href, '_blank')
    },
    goHall(a) {
      //// console.log(a);
      if (this.NowFocus == 4) {
        const { href } = this.$router.resolve({
          path: '/resultDialogcopy',
          query: {
            id: a.ID,
          },
        })
        window.open(href, '_blank')
      } else if (this.NowFocus == 5) {
        const { href } = this.$router.resolve({
          path: '/demandDialogCopy',
          query: {
            id: a.ID,
          },
        })
        window.open(href, '_blank')
      } else if (this.NowFocus == 6) {
        const { href } = this.$router.resolve({
          path: '/yunDetail',
          query: {
            id: a.ID,
          },
        })
        window.open(href, '_blank')
      }
    },
    ToNewsInfo(i) {
      if (this.NowFocus == 7) {
        let routeData = this.$router.resolve({
          path: '/NewsInfo',
          query: {
            id: i.ID,
            type: 0,
          },
        })
        window.open(routeData.href, '_blank')
      } else if (this.NowFocus == 8) {
        let routeData = this.$router.resolve({
          path: '/NewsInfo',
          query: {
            id: i.ID,
            type: 1,
          },
        })
        window.open(routeData.href, '_blank')
      } else if (this.NowFocus == 9) {
        let routeData = this.$router.resolve({
          path: '/NewsInfo',
          query: {
            id: i.ID,
            type: 2,
          },
        })
        window.open(routeData.href, '_blank')
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.head {
  width: 100%;
  height: 21.875rem;
  background-image: url('../assets/images/组 3826@2x.png');
  background-size: 100% 21.875rem;
}
.el-form--inline .el-form-item {
  margin-right: 0;
}
.form {
  width: 45rem;
  height: 4rem;
  margin: 0 auto;
  padding-top: 5.75rem;
  .el-input {
    width: 37.25rem;
    /deep/.el-input__inner {
      height: 4rem !important;
      padding-left: 3.5rem;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      opacity: 1;
      border-radius: 0.625rem 0 0 0.625rem;
    }
    /deep/ .el-input__prefix {
      left: 1.25rem;
      .el-input__icon {
        font-size: 1.25rem;
        height: 4.5rem;
      }
    }
  }
  .el-button--color {
    background: #2769dc;
    border: none;
    widows: 7.75rem;
    height: 4rem;
    border-radius: 0 0.625rem 0.625rem 0;
    ::v-deep span {
      font-size: 1.25rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 0rem;
      color: #ffffff;
      opacity: 1;
    }
  }
}
.container {
  // height: 140.25rem;
  background: #fff;
  box-sizing: border-box;
  margin: -6.9375rem auto 3.75rem;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  width: 87.5rem;
  padding: 1.875rem;
}
.globalTitle {
  width: 87.5rem;
  margin: 0.5rem auto 1.875rem;
  color: #999999;
  font-size: 1.25rem;
  position: relative;
  text-align: left;
}
.globalTitle > img {
  width: 10.8125rem;
  display: inline-block;
  vertical-align: middle;
}
.globalTitle > div {
  // width: 76.6875rem;
  height: 3.75rem;
  display: inline-block;
}
.globalTitle > div > h3 {
  font-size: 1.875rem;
  font-weight: 600;
  display: inline;
  color: #333;
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
.globalTitle > div > span {
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.625rem;
}
.AllType {
  text-align: left;
  li {
    cursor: pointer;
    width: 7.125rem;
    height: 2.25rem;
    border: 0.0625rem solid #2769dc;
    opacity: 1;
    font-size: 1rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-align: center;
    color: #2769dc;
    border-radius: 0.25rem;
    display: inline-block;
    line-height: 2.25rem;
    margin-right: 0.625rem;
  }
  .focus {
    background: #2769dc;
    color: #fff;
  }
}
.dataNum {
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin: 1.875rem 0;
  line-height: 1;
  text-align: left;
  color: #999999;
  span {
    color: #f15916;
  }
}
.NowResult {
  .isResFocus {
    border: 0.0625rem solid #2769dc;
    box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  }
  li {
    text-align: left;
    height: 10.5rem;
    border-bottom: 0.0625rem solid #e2e2e2;
    display: flex;
    cursor: pointer;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
    padding: 1.875rem;
    margin-bottom: 1.25rem;

    .leftContent {
      p {
        width: 56.9375rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0.875rem 0 1.5rem;
      }
      .xing_wrap {
        span {
          margin-right: 0.3125rem;
        }
      }
    }
    .rightContent {
      height: 7.5rem;
      width: 9.5rem;
      border-left: 0.0625rem dashed #999999;
      text-align: right;
      font-size: 0.875rem;
      font-family: Source Han Sans CN;
      color: #aaa;
      padding-top: 1.75rem;

      .botm {
        font-size: 1.8125rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 1.875rem;
        color: #f15916;
        margin-top: 0.625rem;
      }
    }
  }
}
.PersonalContainer {
  text-align: left;
}
.PersonalInfo {
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
  margin: 1.75rem 1rem 0 0;
  width: 19.75rem;
  height: 21.375rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  .Name {
    width: 16.75rem;
    height: 7.0625rem;
    background: #f7f7f7;
    position: relative;
    margin: 4.25rem auto 0;
    padding: 1.875rem 0 0 1.5rem;
    box-sizing: border-box;
    p {
      font-size: 1.375rem;
      height: auto;
      text-align: left;
      font-family: Microsoft YaHei;
      font-weight: bold;
      margin: 0;
    }
    span {
      color: #999999;
      font-size: 1rem;
    }
    img {
      position: absolute;
      width: 8.8125rem;
      height: 9.875rem;
      right: 0;
      bottom: 0;
    }
  }
  .Name::before {
    clear: both;
    width: 0.1875rem;
    height: 3.25rem;
    background: #0561d2;
    position: absolute;
    margin: auto;
    left: 0;
    top: 0;
    bottom: 0;
    content: '';
  }
  p {
    font-size: 0.9375rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    text-align: center;
    color: #666666;
    margin: 2.0625rem 1.5rem 0.8125rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 1.25rem;
  }
  .specialLen {
    margin: 0 1.5rem;
    font-size: 0.75rem;
    font-family: Source Han Sans CN;
    font-weight: 400;

    color: #999999;
    i {
      font-style: inherit;
    }
    span {
      width: 7.875rem;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
      text-align: center;
    }
  }
  .el-button {
    width: 6.3125rem;
    height: 2.1875rem;
    background: #2769dc;
    padding: 0;
    text-align: center;
    line-height: 2.1875rem;
    margin-top: 1.625rem;
    margin-left: 6.5rem;
  }
}
.card_box {
  display: flex;
  justify-content: space-between;
  margin-top: 1.875rem;
  flex-wrap: wrap;
  &:after {
    content: '';
    width: 27.6875rem;
  }
  .card {
    &:hover {
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
      // background-color: red;
      cursor: pointer;
    }
    width: 27.6875rem;
    height: 24.5rem;
    background: #ffffff;
    opacity: 1;
    border-radius: 0rem;
    margin-bottom: 3.125rem;
    img {
      width: 100%;
      vertical-align: bottom;
    }
    .card_text {
      height: 9.5rem;
      text-align: left;
      margin: 1.4375rem 1.5rem;
      .card_name {
        width: 100%;
        text-align: left;
        font-size: 1.1875rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 1.6875rem;
        color: #0561d2;
        opacity: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .card_add {
        width: 100%;
        font-size: 0.875rem;
        text-align: left;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 1.75rem;
        color: #aaaaaa;
        opacity: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-top: 0.75rem;
      }
      .card_pop_wrap {
        margin-top: 1.25rem;
        .card_pop {
          background: #e0dfdf;
          border-radius: 0.9375rem;
          font-size: 0.8125rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 0rem;
          color: #666666;
          opacity: 1;
          padding: 0.3125rem;
          margin-top: 1.25rem;
          margin-right: 0.625rem;
        }
      }
    }
  }
}
// .card_box:after {
//   content: "";
//   width: 30%;
//   height: 0rem;
//   // visibility: hidden;
//   // display: none;
//   cursor: none;
// }
.new {
  margin-top: 1.875rem;
  .new:hover {
    box-shadow: 0.3125rem 0.3125rem 0.375rem 0.1875rem #999;
  }
  .item {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 1.625rem;
    &:hover {
      box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
    }
  }
  .totle {
    width: 6.875rem;
    height: 6.875rem;
    background: #dbebfc;
    p {
      font-size: 2.25rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #2769dc;
      opacity: 1;
      margin-top: 1.375rem;
    }
  }
  .totledate-top {
    width: 100%;
    height: 3rem;
    line-height: 3.75rem;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 0.1875rem 0.1875rem 0rem 0rem;
  }
  .totledate-top span {
    color: rgb(255, 255, 255);
    font-weight: 400;
    font-size: 1.625rem;
  }
  .totledate-bottom {
    p {
      margin-top: 1rem;
      font-size: 0.875rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #686f88;
      opacity: 1;
    }
  }
  .content {
    margin-left: 1.5625rem;
    padding-top: 1.25rem;
    padding-right: 1.25rem;
    line-height: 1.375rem;
    text-align: left;
    box-sizing: border-box;
    width: 71.25rem;
  }
  .content b {
    display: block;
    text-align: left !important;
    color: #333;
    font-size: 1.125rem;
    padding-bottom: 0.7rem;
  }
  .con-div {
    font-size: 1rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    opacity: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
}
.yunshow {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  .yunshow_wrap {
    cursor: pointer;
    width: 47%;
    &:hover {
      box-shadow: 0rem 0.1875rem 1.125rem rgba(0, 0, 0, 0.08);
    }
    display: flex;
    justify-content: flex-start;
    padding: 1.6875rem 1.25rem;
    .img_box {
      width: 12.6875rem;
      height: 6.875rem;
      img {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
      }
    }
    .text_box {
      text-align: left;
      margin-left: 1.1875rem;
      .title {
        font-size: 1.125rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #4a4a4a;
        opacity: 1;
        margin-bottom: 0.8125rem;
      }
      .danwei {
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        opacity: 1;
        padding-bottom: 0.3125rem;
      }
    }
  }
}
</style>